// extracted by mini-css-extract-plugin
export default {"imageWrapper":"Step5_imageWrapper__sp5fT","selected":"Step5_selected__CgGlX"};